<template lang="html">
    <div class="select">
        <ul >
            <li v-for='(item,index) in list'
            :class="idxId==index?'active':''"
            @click.prevent='handleClick($event,index,item)'>
            {{item.name}}
        </li>
    </ul>
</div>
</template>

<script>
export default {
  name: 'NavMenu',
  props: ['list', 'idxId'],
  methods: {
    handleClick: function (e, idx, item) {
      if (item.path) {
        this.$router.push({
          path: item.path,
          query: item.data ? item.data : {}
        })
      }
      this.$emit('handleClick', idx, item)
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  ul {
    padding: 12px 0 0 20px;
    margin-top: 20px;
    li {
      font-size: 18px;
      cursor: pointer;
      height: 30px;
      text-align: center;
      float: left;
      width: auto;
      margin: 0 25px 20px 0;
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
    li.active {
      color: rgba(46, 121, 208, 1);
      &::after {
        display: block;
        content: "";
        width: auto;
        height: 4px;
        background: rgba(46, 121, 208, 1);
        margin: 10px auto;
      }
    }
  }
}
</style>
